import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { Board, BoardBackend } from '../../../core/board/board';
import { BoardFuncs } from '../../../core/board/board.func';
import { BoardIconComponent } from '../board-icon/board-icon.component';

@Component({
  selector: 'app-board-icon-title',
  standalone: true,
  imports: [CommonModule, MatTooltipModule, NzToolTipModule, BoardIconComponent],
  templateUrl: './board-icon-title.component.html',
  styleUrl: './board-icon-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoardIconTitleComponent {
  @Input() board?: Board | BoardBackend;
  @Input() isForAssignee = false;

  @Input() size = 34;

  @Input() hasTooltip = false;

  @Input() canOpen = false;

  isMouseEnter = false;

  constructor(private router: Router) {}

  onMouseEnter() {
    this.isMouseEnter = true;
  }

  onMouseLeave() {
    this.isMouseEnter = false;
  }

  onClick() {
    // if (this.canOpen) {
    //   this.router.navigate(['/app', this.board?.settings.defaultViewId]);
    // }
  }

  getStyle(): CSSStyleDeclaration {
    const style = {} as CSSStyleDeclaration;

    if (this.canOpen && this.isMouseEnter) {
      style.backgroundColor = '#f5f5f569';
      style.cursor = 'pointer';
    } else {
      style.backgroundColor = 'transparent';
      style.cursor = 'default';
    }

    return style;
  }

  getToolTip() {
    if (!this.hasTooltip) {
      return '';
    }
    if (this.canOpen) {
      return `Click to Open`;
    }
    return this.getBoardName(this.board);
  }

  getBoardName(board?: Board | BoardBackend) {
    if (!board) {
      return '';
    }
    if (!this.isForAssignee) {
      return BoardFuncs.getNameWithoutFirstEmoji(board);
    } else {
      if (BoardFuncs.isPersonal(board)) {
        return BoardFuncs.getNameWithoutFirstEmoji(board);
      } else {
        return `Unassigned (${BoardFuncs.getNameWithoutFirstEmoji(board)})`;
      }
    }
  }
}
